export function nextTestimonialIndex(current: number, count: number, direction: 1 | -1): number {
  if (count <= 1) return 0;
  return (current + direction + count) % count;
}

export function testimonialRatingLabel(rating: number | null): string | undefined {
  if (!rating || rating < 1 || rating > 5) return undefined;
  return `${'★'.repeat(rating)}${'☆'.repeat(5 - rating)}`;
}
